// extracted by mini-css-extract-plugin
module.exports = {"tab_title_bar":"tabtitlebar_tab_title_bar__2sMd_"};